exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".switch_box[data-v-9260807a]{width:34px;background-color:#e4e4e4;border-radius:4px;overflow:hidden;cursor:pointer}.switch_box.active[data-v-9260807a]{background-color:#1abc9c}.switch_box .switch_child[data-v-9260807a]{background-color:#a4a4a4;width:18px;height:16px;line-height:16px;text-align:center;color:#fff;font-size:12px;border-radius:4px;-webkit-transition:all .5s;transition:all .5s;-webkit-transform:rotateX(0);transform:rotateX(0)}.switch_box .switch_child.child_active[data-v-9260807a]{background-color:#34495e;-webkit-transform:translateX(16px);transform:translateX(16px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9260807a","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/switch-button/index.vue
// module id = 2sZ5
// module chunks = 0 7 12 13 14 17 26 28 30 32 34 52 65 134